module.exports = __webpack_public_path__ + "img/sec_3_box3.c0628829.png";